import request from './api'
/**
 *    教室设置  任务库api
 * */

/**
 *  Author by zyp. on 202.6.16
 */

// // 获取任务列表
export const getSetUpList = (params, opts) =>
    request('/api-course/classSet/findAll', params, {
        ...opts,
        method: 'post'
    });
//修改
export const setData = (params, opts) =>
    request('/api-course/classSet/batchUpdateSet', params, {
        ...opts,
        method: 'post'
    });

// // 组建任务
// export const postSaveTask = (params, opts) =>
//     request('/api-resource/taskEventres/saveTask', params, {
//         ...opts,
//         method: 'post',
//     });
// // 修改任务
// export const postUpdateTask = (params, opts) =>
//     request('/api-resource/taskEventres/updateTask', params, {
//         ...opts,
//         method: 'post',
//     });

// // 根据ID获取任务详情
// export const getTaskListById = (id, params, opts) =>
//     request('/api-resource/taskEventres/qryEventsAndTaskByTaskId/'+ id, params, opts);


// // 在实操题添加事项页面用到，用于获取任务列表
// export const getTaskListByName = (name, params, opts) =>
//     request('/api-resource/taskEventres/queryTaskAndEventsList/'+ name, params, opts);


// // 删除任务
// export const DelTask = (id, params, opts) =>
//     request('/api-resource/taskEventres/deleteTask/' +id, params, opts);



// WEBPACK FOOTER //
// ./src/api/teacherSetUpApi.js